import React from 'react'

const IconMarkerHome = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <path d='M4 11 L12 4 L20 11' />
         <path d='M6 9.5 V20 H18 V9.5' />
      </svg>
   )
}
export default IconMarkerHome
